export default {
  id: 'ID',
  team: 'TEAM',
  nation: 'NATION',
  name: 'NAME',
  email: 'EMAIL',
  password: 'PASSWORD',
  product: 'PRODUCT',
  project: 'PROJECT',
  IdCell: 'IdCell',
  IndexCell: 'IndexCell',
  PeriodCell: 'PeriodCell',
  AttachmentCell: 'AttachmentCell',
  TeamCell: 'TeamCell',
  NameCell: 'NameCell',
  NationalityCell: 'NationalityCell',
  JointCell: 'JointCell',
  LastLoginCell: 'LastLoginCell',
  AccessCell: 'AccessCell',
  EvaluatedCell: 'EvaluatedCell',
  CommentedCell: 'CommentedCell',
  StatusCell: 'StatusCell',
  Input: 'Input',
  TeamSelect: 'TeamSelect',
  CountriesSelect: 'CountriesSelect',
  Avatar: 'Avatar',
  NameInput: 'NameInput',
  PasswordInput: 'PasswordInput',
  PeriodInput: 'PeriodInput',
  ConsultantSelect: 'ConsultantSelect',
  middle: 'middle',
  right: 'right',
  left: 'left',
  select: 'select',
  date: 'date',
};
